/* =========================================================
   Flexi Canap · Page produit (sections FC · Fiche produit, En scène, Description,
   Positions 3D, Avis, Questions). Un seul fichier pour toutes les sections fp.
   Chaque section porte data-fp="..." ; chaque racine est initialisée une seule fois,
   puis relancée quand l'éditeur de thème la reconstruit.
   ========================================================= */
(function () {
  'use strict';
  if (window.FP) return; // le fichier est appelé par plusieurs sections
  var FP = window.FP = {};
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function chaque(l, f) { Array.prototype.forEach.call(l, f); }
  function q(r, s) { return r.querySelector(s); }
  function qa(r, s) { return r.querySelectorAll(s); }

  /* =========================================================
     Glisse : défilement natif + accroche (doigt, pavé tactile),
     tirage souris avec élan puis atterrissage animé.
     ========================================================= */
  function Glisse(piste, o) {
    o = o || {};
    var self = this, anim = null, tire = false, bouge = false, x0 = 0, s0 = 0, v = 0, tx = 0, tt = 0, i0 = 0;
    this.bloque = false;
    this.cibles = function () {
      var max = piste.scrollWidth - piste.clientWidth, pl = parseFloat(getComputedStyle(piste).paddingLeft) || 0;
      return Array.prototype.map.call(piste.children, function (el) {
        var x = o.centre ? el.offsetLeft - (piste.clientWidth - el.offsetWidth) / 2 : el.offsetLeft - pl;
        return Math.max(0, Math.min(max, Math.round(x)));
      });
    };
    this.index = function () {
      var c = self.cibles(), s = piste.scrollLeft, k = 0;
      c.forEach(function (x, j) { if (Math.abs(x - s) < Math.abs(c[k] - s)) k = j; });
      return k;
    };
    this.vers = function (cible, duree) {
      cancelAnimationFrame(anim);
      var d = piste.scrollLeft, delta = cible - d;
      if (Math.abs(delta) < 1 || reduit) { piste.scrollLeft = cible; piste.style.scrollSnapType = ''; return; }
      duree = duree || Math.max(420, Math.min(780, 320 + Math.abs(delta) * 0.35));
      piste.style.scrollSnapType = 'none';
      var t0 = performance.now();
      (function pas(t) {
        var p = Math.min(1, (t - t0) / duree), e = 1 - Math.pow(1 - p, 4);
        piste.scrollLeft = d + delta * e;
        if (p < 1) anim = requestAnimationFrame(pas); else piste.style.scrollSnapType = '';
      })(t0);
    };
    this.aller = function (k) { var c = self.cibles(); k = Math.max(0, Math.min(c.length - 1, k)); self.vers(c[k]); };
    this.pas = function (s) { self.aller(self.index() + s); };
    piste.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || self.bloque) return;
      cancelAnimationFrame(anim);
      tire = true; bouge = false; x0 = e.clientX; s0 = piste.scrollLeft; v = 0; tx = e.clientX; tt = performance.now(); i0 = self.index();
    });
    window.addEventListener('pointermove', function (e) {
      if (!tire) return;
      var dx = e.clientX - x0;
      if (!bouge && Math.abs(dx) > 5) { bouge = true; piste.style.scrollSnapType = 'none'; piste.classList.add('fp-tire'); }
      if (!bouge) return;
      var t = performance.now(), dt = Math.max(1, t - tt);
      v = 0.8 * ((e.clientX - tx) / dt) + 0.2 * v; tx = e.clientX; tt = t;
      piste.scrollLeft = s0 - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!tire) return;
      tire = false; piste.classList.remove('fp-tire');
      if (!bouge) return;
      var c = self.cibles(), proj = piste.scrollLeft - v * 220, k = 0;
      c.forEach(function (x, j) { if (Math.abs(x - proj) < Math.abs(c[k] - proj)) k = j; });
      if (o.unParUn) k = Math.max(i0 - 1, Math.min(i0 + 1, k));
      self.vers(c[k]);
      /* le relâchement d'un glissé n'ouvre pas la photo */
      piste.addEventListener('click', function (ev) { ev.stopPropagation(); ev.preventDefault(); }, { capture: true, once: true });
    });
    piste.addEventListener('dragstart', function (e) { e.preventDefault(); });
    piste.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.pas(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.pas(-1); }
    });
    if (o.suivi) {
      var en = false;
      piste.addEventListener('scroll', function () { if (en) return; en = true; requestAnimationFrame(function () { en = false; o.suivi(self); }); }, { passive: true });
      window.addEventListener('resize', function () { o.suivi(self); });
    }
  }
  FP.Glisse = Glisse;

  /* boutons précédent / suivant reliés à une piste, grisés aux extrémités */
  function fleches(g, piste, p, s) {
    if (!p || !s) return;
    p.addEventListener('click', function () { g.pas(-1); });
    s.addEventListener('click', function () { g.pas(1); });
    function maj() { var m = piste.scrollWidth - piste.clientWidth; p.disabled = piste.scrollLeft < 4; s.disabled = piste.scrollLeft > m - 4; }
    piste.addEventListener('scroll', maj, { passive: true }); window.addEventListener('resize', maj); maj();
  }

  /* ---------- Accordéons (description, questions) ---------- */
  function accordeons(racine) {
    chaque(qa(racine, '.fp-acc__bouton'), function (b) {
      b.addEventListener('click', function () {
        var a = b.parentNode, o = a.hasAttribute('data-ouvert');
        if (o) a.removeAttribute('data-ouvert'); else a.setAttribute('data-ouvert', '');
        b.setAttribute('aria-expanded', !o);
      });
    });
  }
  FP.description = accordeons;
  FP.faq = accordeons;
  FP.avis = function () {};

  /* ---------- Livraison : jours ouvrés (hors week-ends et jours fériés français) ---------- */
  function paques(a) { /* dimanche de Pâques (algorithme de Meeus) */
    var b = a % 19, c = Math.floor(a / 100), d = a % 100, e = Math.floor(c / 4), f = c % 4, g = Math.floor((c + 8) / 25), h = Math.floor((c - g + 1) / 3),
      i = (19 * b + c - e - h + 15) % 30, k = Math.floor(d / 4), l = d % 4, m = (32 + 2 * f + 2 * k - i - l) % 7, n = Math.floor((b + 11 * i + 22 * m) / 451),
      mois = Math.floor((i + m - 7 * n + 114) / 31), jour = ((i + m - 7 * n + 114) % 31) + 1;
    return new Date(a, mois - 1, jour);
  }
  function ferie(d) {
    var cle = (d.getMonth() + 1) + '-' + d.getDate();
    if (['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25'].indexOf(cle) > -1) return true;
    var p = paques(d.getFullYear());
    return [1, 39, 50].some(function (j) { var x = new Date(p); x.setDate(p.getDate() + j); return x.getMonth() === d.getMonth() && x.getDate() === d.getDate(); });
  }
  function plusJoursOuvres(n) {
    var d = new Date(); d.setHours(12, 0, 0, 0);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6 && !ferie(d)) n--; }
    return d;
  }
  function dates(el) {
    var modele = el.getAttribute('data-modele');
    if (!modele || modele.indexOf('[min]') < 0) return;
    var a = plusJoursOuvres(parseInt(el.getAttribute('data-min'), 10) || 4), b = plusJoursOuvres(parseInt(el.getAttribute('data-max'), 10) || 10);
    var jour = function (d) { return new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric' }).format(d); };
    var mois = function (d) { return new Intl.DateTimeFormat('fr-FR', { month: 'short' }).format(d); };
    el.textContent = modele.replace('[min]', jour(a) + (a.getMonth() !== b.getMonth() ? ' ' + mois(a) : '')).replace('[max]', jour(b) + ' ' + mois(b));
  }

  /* ---------- Argent : même présentation que Shopify (1 080,00 €) ---------- */
  function argent(centimes) {
    var dev = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: dev }).format(centimes / 100).replace(/[  ]/g, ' '); }
    catch (e) { return (centimes / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  /* ---------- Lecteur 3D : celui de Shopify, sinon la bibliothèque officielle de Google ---------- */
  FP.lecteur3d = function () {
    if (FP.l3d || (window.customElements && customElements.get('model-viewer'))) return;
    FP.l3d = true;
    if (window.FC && FC.lecteur3d) { FC.lecteur3d(); return; } /* même chargeur que l'accueil */
    function google() {
      if (!window.customElements || customElements.get('model-viewer') || FP.l3dGoogle) return;
      FP.l3dGoogle = true;
      var s = document.createElement('script'); s.type = 'module';
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
      document.head.appendChild(s);
    }
    if (window.Shopify && Shopify.loadFeatures) {
      try {
        Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: function () {
          var fini = false; customElements.whenDefined('model-viewer').then(function () { fini = true; });
          setTimeout(function () { if (!fini) google(); }, 2000);
        } }]);
      } catch (e) { google(); }
      setTimeout(google, 6000);
    } else google();
  };

  /* ---------- Événements standard de Shopify (panier latéral du thème) ----------
     Chargés par un petit script module : Shopify réécrit les imports dynamiques des
     fichiers classiques à la publication, ce qui les casse. */
  function evenementsShopify() {
    if (FP.ev) return FP.ev;
    FP.ev = new Promise(function (ok) {
      if (window.FPShopifyEvents) { ok(window.FPShopifyEvents); return; }
      var fini = false, fin = function () { if (!fini) { fini = true; ok(window.FPShopifyEvents || null); } };
      document.addEventListener('fp:evenements', fin, { once: true });
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = "import * as m from '@shopify/events'; window.FPShopifyEvents = m; document.dispatchEvent(new Event('fp:evenements'));";
      s.onerror = fin;
      document.head.appendChild(s);
      setTimeout(fin, 4000);
    });
    return FP.ev;
  }
  FP.evenements = evenementsShopify;

  /* =========================================================
     1. Fiche produit
     ========================================================= */
  var cacheSections = {};
  FP.produit = function (racine) {
    var id = racine.getAttribute('data-section');
    /* message, visionneuse et barre : sous <body>, à l'abri des contextes d'empilement du thème */
    chaque(qa(document, 'body > [data-fp-de="' + id + '"]'), function (el) { el.remove(); });
    var toast = q(racine, '[data-fp-toast]'), visio = q(racine, '[data-fp-visio]'), barre = q(racine, '[data-fp-barre]');
    [toast, visio, barre].forEach(function (el) { if (el) { el.setAttribute('data-fp-de', id); document.body.appendChild(el); } });
    racine.fpSatellites = [toast, visio, barre];

    var mosaique = q(racine, '[data-fp-mosaique]'), piste = q(racine, '[data-fp-piste]');
    var vignettes = q(racine, '[data-fp-vignettes]'), tirets = q(racine, '[data-fp-tirets]'), dernier = -1;

    /* ----- Galerie téléphone : profondeur pendant le glissé, tirets et vignettes qui suivent ----- */
    var galerie = null;
    if (piste) {
      galerie = new Glisse(piste, { unParUn: true, suivi: suivi });
      piste.addEventListener('click', function () { ouvrirVisio(galerie.index()); });
      if (vignettes) chaque(vignettes.children, function (b, i) { b.addEventListener('click', function () { galerie.aller(i); }); });
    }
    function suivi() {
      var w = piste.clientWidth || 1, s = piste.scrollLeft;
      if (!reduit) chaque(piste.children, function (d) {
        var off = (d.offsetLeft - s) / w, a = Math.min(1, Math.abs(off)), m = d.firstElementChild;
        if (m) m.style.transform = a < 0.001 ? '' : 'translate3d(' + (-off * 7) + '%,0,0) scale(' + (1 + a * 0.05) + ')';
      });
      var k = Math.round(s / w);
      if (k === dernier) return; dernier = k;
      if (tirets) chaque(tirets.children, function (t, j) { t.classList.toggle('fp-actif', j === k); });
      if (vignettes) {
        chaque(vignettes.children, function (b, j) { b.setAttribute('aria-current', j === k); });
        var v = vignettes.children[k];
        if (v) { var vr = v.getBoundingClientRect(), cr = vignettes.getBoundingClientRect(); if (vr.left < cr.left || vr.right > cr.right) vignettes.scrollTo({ left: vignettes.scrollLeft + vr.left - cr.left - 6, behavior: 'smooth' }); }
      }
    }

    /* ----- Visionneuse plein écran : glisser, flèches, clavier, zoom au clic ----- */
    var tuiles = mosaique ? Array.prototype.slice.call(qa(mosaique, '.fp-tuile[data-grand]')) : [];
    tuiles.forEach(function (b, i) { b.addEventListener('click', function () { ouvrirVisio(i); }); });
    var vp = visio && q(visio, '[data-fp-visio-piste]'), vg = null, compteur = visio && q(visio, '[data-fp-compteur]');
    function ouvrirVisio(k) {
      if (!visio || !tuiles.length) return;
      vp.innerHTML = tuiles.map(function (t) { return '<div><img src="' + t.getAttribute('data-grand') + '" alt="' + (t.getAttribute('data-alt') || '') + '" draggable="false"></div>'; }).join('');
      visio.hidden = false;
      document.documentElement.classList.add('fp-bloque');
      requestAnimationFrame(function () {
        visio.classList.add('fp-visible');
        if (!vg) vg = new Glisse(vp, { unParUn: true, suivi: function (g) { compteur.textContent = (g.index() + 1) + ' / ' + vp.children.length; } });
        vp.scrollLeft = vg.cibles()[k] || 0;
        compteur.textContent = (k + 1) + ' / ' + tuiles.length;
        q(visio, '[data-fp-fermer]').focus();
      });
    }
    function fermerVisio() {
      visio.classList.remove('fp-visible');
      document.documentElement.classList.remove('fp-bloque');
      if (galerie && vg) galerie.aller(vg.index());
      setTimeout(function () { visio.hidden = true; vp.innerHTML = ''; }, 350);
    }
    if (visio) {
      q(visio, '[data-fp-fermer]').addEventListener('click', fermerVisio);
      q(visio, '[data-fp-visio-prec]').addEventListener('click', function () { if (vg) vg.pas(-1); });
      q(visio, '[data-fp-visio-suiv]').addEventListener('click', function () { if (vg) vg.pas(1); });
      document.addEventListener('keydown', function (e) {
        if (visio.hidden || !visio.isConnected) return;
        if (e.key === 'Escape') fermerVisio();
        if (e.key === 'ArrowRight' && vg) vg.pas(1);
        if (e.key === 'ArrowLeft' && vg) vg.pas(-1);
      });
      /* zoom : un clic agrandit à l'endroit visé, la souris promène le zoom */
      vp.addEventListener('click', function (e) {
        var d = e.target.closest('[data-fp-visio-piste] > div'); if (!d) return;
        var img = d.firstChild, r = img.getBoundingClientRect();
        if (!d.classList.contains('fp-zoom')) {
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          d.classList.add('fp-zoom'); if (vg) vg.bloque = true; vp.style.overflowX = 'hidden';
        } else { d.classList.remove('fp-zoom'); if (vg) vg.bloque = false; vp.style.overflowX = ''; }
      });
      vp.addEventListener('pointermove', function (e) {
        var d = q(vp, '.fp-zoom'); if (!d) return;
        var r = d.getBoundingClientRect();
        d.firstChild.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    }

    /* ----- Badges en verre : le reflet suit le pointeur, un toucher ouvre le détail ----- */
    var zoneBadges = q(racine, '[data-fp-badges]');
    if (zoneBadges) {
      var badges = qa(zoneBadges, '.fp-badge'), detail = q(zoneBadges, '.fp-badges__detail'), texte = q(zoneBadges, '[data-fp-badge-texte]');
      chaque(badges, function (b) {
        b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); b.style.setProperty('--x', (e.clientX - r.left) + 'px'); b.style.setProperty('--y', (e.clientY - r.top) + 'px'); });
        b.addEventListener('click', function () {
          var ouvert = b.getAttribute('aria-expanded') === 'true';
          chaque(badges, function (x) { x.setAttribute('aria-expanded', 'false'); });
          if (ouvert || !b.getAttribute('data-detail')) { detail.classList.remove('fp-ouvert'); return; }
          b.setAttribute('aria-expanded', 'true');
          if (detail.classList.contains('fp-ouvert')) { texte.style.opacity = 0; setTimeout(function () { texte.textContent = b.getAttribute('data-detail'); texte.style.opacity = 1; }, 150); }
          else { texte.textContent = b.getAttribute('data-detail'); detail.classList.add('fp-ouvert'); }
        });
      });
    }

    /* ----- Onglets : trait qui glisse, contenus en fondu, hauteur stable ----- */
    var zoneOnglets = q(racine, '[data-fp-onglets]');
    if (zoneOnglets) {
      var onglets = qa(zoneOnglets, '.fp-onglet'), panneaux = qa(zoneOnglets, '.fp-panneau'), trait = q(zoneOnglets, '.fp-onglets__trait');
      function activer(k) {
        chaque(onglets, function (x, j) { x.setAttribute('aria-selected', j === k); });
        chaque(panneaux, function (x, j) { if (j === k) x.setAttribute('data-actif', ''); else x.removeAttribute('data-actif'); });
        trait.style.transform = 'translateX(' + (k * 100) + '%)';
      }
      chaque(onglets, function (b, k) { b.addEventListener('click', function () { activer(k); }); });
      chaque(onglets, function (b, k) { if (b.getAttribute('aria-selected') === 'true') trait.style.transform = 'translateX(' + (k * 100) + '%)'; });
      /* éditeur : sélectionner un bloc onglet l'affiche */
      document.addEventListener('shopify:block:select', function (e) { chaque(onglets, function (b, k) { if (b.contains(e.target) || b === e.target) activer(k); }); });
    }

    /* ----- Livraison : dates du jour ----- */
    var liv = q(racine, '[data-fp-livraison]');
    if (liv) dates(liv);

    /* ----- Variantes (si le produit en a plusieurs) ----- */
    var form = q(racine, '[data-fp-form]'), champId = form && q(form, '[data-fp-id]'), select = q(racine, '[data-fp-variantes]');
    var boutons = [q(racine, '[data-fp-ajouter]'), barre && q(barre, '[data-fp-ajouter-barre]')].filter(Boolean);
    if (select && champId) select.addEventListener('change', function () {
      var o = select.options[select.selectedIndex], p = parseInt(o.getAttribute('data-prix'), 10), dispo = o.getAttribute('data-dispo') === 'true';
      champId.value = o.value;
      var pr = q(racine, '[data-fp-prix]'); if (pr) pr.textContent = argent(p);
      var kl = q(racine, '[data-fp-klarna]'); if (kl) { var n = parseInt(kl.getAttribute('data-fois'), 10) || 4; kl.textContent = n + ' × ' + argent(Math.floor(p / n)); }
      if (barre) { var bp = q(barre, '.fp-barre__txt b'); if (bp) bp.textContent = argent(p); }
      boutons.forEach(function (b) { b.disabled = !dispo; });
    });

    /* ----- Couleurs : chaque couleur est un produit ; on remplace la fiche sans recharger la page ----- */
    function charger(url) {
      var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
      if (!cacheSections[u]) cacheSections[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
      return cacheSections[u];
    }
    chaque(qa(racine, '[data-fp-coloris]'), function (a) {
      a.addEventListener('pointerenter', function () { if (a.getAttribute('aria-current') !== 'true') charger(a.getAttribute('href')).catch(function () {}); }, { once: true });
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || a.getAttribute('aria-current') === 'true') { if (a.getAttribute('aria-current') === 'true') e.preventDefault(); return; }
        e.preventDefault();
        var url = a.getAttribute('href');
        if (mosaique) mosaique.classList.add('fp-change');
        if (piste) piste.classList.add('fp-change');
        var t0 = performance.now();
        charger(url).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'), neuf = doc.querySelector('.fp-section-produit');
          if (!neuf) throw new Error('section absente');
          setTimeout(function () {
            var m2 = q(neuf, '[data-fp-mosaique]'), p2 = q(neuf, '[data-fp-piste]');
            if (m2) m2.classList.add('fp-change'); if (p2) p2.classList.add('fp-change');
            (racine.fpSatellites || []).forEach(function (el) { if (el) el.remove(); });
            racine.replaceWith(neuf);
            try { history.replaceState(history.state, '', url); } catch (er) {}
            var titre = neuf.getAttribute('data-titre-page'); if (titre) document.title = titre;
            lancer(neuf.parentNode);
            var img = (m2 && m2.offsetParent ? q(m2, 'img') : p2 && q(p2, 'img'));
            var montrer = function () { requestAnimationFrame(function () { if (m2) m2.classList.remove('fp-change'); if (p2) p2.classList.remove('fp-change'); }); };
            if (!img || img.complete) montrer(); else { img.addEventListener('load', montrer, { once: true }); setTimeout(montrer, 700); }
          }, Math.max(0, (reduit ? 0 : 300) - (performance.now() - t0)));
        }).catch(function () { window.location.href = url; });
      });
    });

    /* ----- Panier : ajout sans quitter la page, puis message, panier latéral ou page panier ----- */
    evenementsShopify(); /* préchargé : le clic est instantané */
    var apres = racine.getAttribute('data-apres') || 'message', mt = null, evenementOk = false;
    function tiroir() {
      var t = document.getElementById('cart-drawer');
      if (!t || typeof t.open !== 'function') return false;
      if (!t.isOpen) t.open();
      return true;
    }
    /* ouverture immédiate au clic, comme le bouton du thème ; panier vide : on attend la réponse pour ne pas montrer « panier vide » */
    function tiroirImmediat() {
      var t = document.getElementById('cart-drawer');
      if (!t || typeof t.open !== 'function' || t.querySelector('.cart-drawer--empty')) return;
      try { if (!t.isOpen) t.open(); } catch (er) {}
    }
    function bulle(nb) {
      chaque(qa(document, '[data-fc-panier]'), function (p) {
        var b = q(p, '.fc-bulle');
        if (!b && nb > 0) { b = document.createElement('span'); b.className = 'fc-bulle'; p.appendChild(b); }
        if (b) { b.textContent = nb; b.hidden = nb < 1; b.animate && !reduit && b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.45)' }, { transform: 'scale(1)' }], { duration: 500, easing: 'cubic-bezier(.16,1,.3,1)' }); }
      });
    }
    function message(titre, texte, erreur) {
      if (!toast) return;
      q(toast, '[data-fp-toast-titre]').textContent = titre;
      q(toast, '[data-fp-toast-texte]').textContent = texte;
      toast.classList.toggle('fp-toast--erreur', !!erreur);
      toast.classList.add('fp-visible');
      clearTimeout(mt); mt = setTimeout(function () { toast.classList.remove('fp-visible'); }, erreur ? 6000 : 3200);
    }
    if (toast) q(toast, '[data-fp-voir-panier]').addEventListener('click', function (e) {
      if (evenementOk && tiroir()) { e.preventDefault(); toast.classList.remove('fp-visible'); }
    });
    function ajouter(btn) {
      if (!form || btn.disabled || btn.classList.contains('fp-charge')) return;
      boutons.forEach(function (b) { b.classList.add('fp-charge'); });
      var fd = new FormData(form), varId = champId.value;
      var ids = Array.prototype.map.call(qa(document, 'cart-items-component[data-section-id]'), function (c) { return c.getAttribute('data-section-id'); });
      if (ids.length) fd.append('sections', ids.join(','));
      var routes = (window.Theme && Theme.routes) || {}, urlAjout = routes.cart_add_url || '/cart/add.js', urlPanier = (routes.cart_url || '/cart') + '.js';
      /* événement standard de Shopify : le thème met à jour son panier latéral comme avec son propre bouton */
      var Ev = null, diff = null;
      var pret = evenementsShopify().then(function (m) { Ev = m && m.CartLinesUpdateEvent; }).catch(function () {});
      pret.then(function () {
        if (Ev) {
          try {
            diff = Ev.createPromise();
            form.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(varId), quantity: 1 }], promise: diff.promise }));
          } catch (er) { diff = null; }
          if (diff && apres === 'tiroir') tiroirImmediat();
        }
        return fetch(urlAjout, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
      }).then(function (r) { return r.json(); }).then(function (rep) {
        return fetch(urlPanier, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (panier) {
          var erreur = !!rep.status;
          if (diff) {
            try {
              diff.resolve({ cart: Ev.createCartFromAjaxResponse(panier), detail: { items: panier.items, source: 'fp-produit', sourceId: id, itemCount: 1, productId: racine.getAttribute('data-produit'), sections: rep.sections, didError: erreur } });
              evenementOk = !erreur;
            } catch (er) { evenementOk = false; }
          }
          boutons.forEach(function (b) { b.classList.remove('fp-charge'); });
          if (erreur) { message(rep.message || 'Ajout impossible', rep.description || '', true); return; }
          bulle(panier.item_count);
          boutons.forEach(function (b) { b.classList.add('fp-ok'); setTimeout(function () { b.classList.remove('fp-ok'); }, 2000); });
          if (apres === 'panier') { window.location.href = routes.cart_url || '/cart'; return; }
          if (apres === 'tiroir' && evenementOk && tiroir()) return;
          message(racine.getAttribute('data-texte-ok') || 'Ajouté au panier', (rep.product_title || '') + ' · ' + argent(rep.final_line_price || rep.price || 0));
        });
      }).catch(function () {
        if (diff) { try { diff.reject(new Error('ajout')); } catch (er) {} }
        boutons.forEach(function (b) { b.classList.remove('fp-charge'); });
        form.submit(); /* dernier recours : envoi classique du formulaire */
      });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); ajouter(boutons[0]); });
    if (barre) { var bb = q(barre, '[data-fp-ajouter-barre]'); if (bb) bb.addEventListener('click', function () { ajouter(bb); }); }

    /* ----- Barre d'achat collante : visible une fois le bouton principal dépassé, cachée près du pied de page ----- */
    if (barre) {
      var principal = q(racine, '[data-fp-ajouter]'), main = document.querySelector('main') || document.body, attente = false;
      var lire = function () {
        attente = false;
        if (!principal || !principal.isConnected) return;
        var b = principal.getBoundingClientRect(), fin = main.getBoundingClientRect().bottom;
        barre.classList.toggle('fp-visible', b.bottom < 60 && fin > window.innerHeight + 40);
      };
      window.addEventListener('scroll', function () { if (!attente) { attente = true; requestAnimationFrame(lire); } }, { passive: true });
      lire();
    }
  };

  /* =========================================================
     2. En scène : cartes qui glissent, vidéos lancées seulement à l'écran
     ========================================================= */
  FP.scene = function (racine) {
    var piste = q(racine, '[data-fp-piste]'); if (!piste) return;
    var g = new Glisse(piste); fleches(g, piste, q(racine, '[data-fp-prec]'), q(racine, '[data-fp-suiv]'));
    var videos = qa(piste, 'video');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (ent) {
      ent.forEach(function (e) {
        var v = e.target; v.muted = true;
        if (e.isIntersecting && !reduit) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else if (!v.paused) v.pause();
      });
    }, { root: null, threshold: 0.35 });
    chaque(videos, function (v) { v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; io.observe(v); });
  };

  /* =========================================================
     3. Positions : glisser d'un modèle à l'autre, la pastille et le texte suivent
     ========================================================= */
  FP.positions = function (racine) {
    var pp = q(racine, '[data-fp-piste]'); if (!pp) return;
    if (q(pp, 'model-viewer')) FP.lecteur3d();
    var num = q(racine, '[data-fp-num]'), nom = q(racine, '[data-fp-nom]'), txt = q(racine, '[data-fp-texte]');
    var prec = q(racine, '[data-fp-prec]'), suiv = q(racine, '[data-fp-suiv]'), d = -1, n = pp.children.length;
    var g = new Glisse(pp, { unParUn: true, centre: true, suivi: function () {
      var w = pp.clientWidth || 1, s = pp.scrollLeft;
      chaque(pp.children, function (el) {
        var off = (el.offsetLeft - s) / w, a = Math.min(1, Math.abs(off)), t = el.firstElementChild;
        if (t) { t.style.transform = 'translate3d(' + (-off * 18) + '%,0,0) scale(' + (1 - a * 0.12) + ')'; t.style.opacity = 1 - a; }
      });
      var k = Math.max(0, Math.min(n - 1, Math.round(s / w)));
      if (k === d) return; d = k;
      var el = pp.children[k];
      if (num) num.textContent = (k + 1 < 10 ? '0' : '') + (k + 1);
      if (nom) nom.textContent = el.getAttribute('data-nom');
      if (txt) { txt.style.opacity = 0; setTimeout(function () { txt.textContent = el.getAttribute('data-texte'); txt.style.opacity = 1; }, 180); }
      if (prec) prec.disabled = k === 0;
      if (suiv) suiv.disabled = k === n - 1;
    } });
    if (prec) prec.addEventListener('click', function () { g.pas(-1); });
    if (suiv) suiv.addEventListener('click', function () { g.pas(1); });
    pp.dispatchEvent(new Event('scroll'));
    /* éditeur : sélectionner un bloc position l'amène au centre */
    document.addEventListener('shopify:block:select', function (e) { chaque(pp.children, function (el, k) { if (el === e.target) g.aller(k); }); });
  };

  /* =========================================================
     Apparitions au défilement (sections marquées fp-avenir)
     ========================================================= */
  var io = null;
  function apparitions(scope) {
    if (reduit || !('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(function (ent) {
      ent.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('fp-attente'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -60px 0px' });
    chaque(qa(scope, '.fp-avenir'), function (el) {
      if (el.dataset.fpVu) return; el.dataset.fpVu = '1';
      if (el.getBoundingClientRect().top > window.innerHeight - 40) { el.classList.add('fp-attente'); io.observe(el); }
    });
  }

  function lancer(scope) {
    scope = scope || document;
    var liste = Array.prototype.slice.call(qa(scope, '[data-fp]'));
    if (scope.matches && scope.matches('[data-fp]')) liste.unshift(scope);
    liste.forEach(function (r) {
      if (r.dataset.fpPret) return;
      r.dataset.fpPret = '1';
      var f = FP[r.getAttribute('data-fp')];
      if (f) { try { f(r); } catch (e) { if (window.console) console.error('[FC]', e); } }
    });
    apparitions(scope);
  }
  FP.lancer = lancer;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { lancer(); });
  else lancer();
  document.addEventListener('shopify:section:load', function (e) { lancer(e.target); });
  /* pastille du panier : se recale sur le vrai nombre d'articles quand un autre script modifie le panier
     (ex. les coussins offerts ajoutés automatiquement après le canapé) */
  var recalage = null;
  function recalerBulle() {
    clearTimeout(recalage);
    recalage = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        chaque(qa(document, '[data-fc-panier]'), function (p) {
          var b = q(p, '.fc-bulle');
          if (!b && c.item_count > 0) { b = document.createElement('span'); b.className = 'fc-bulle'; p.appendChild(b); }
          if (b) { b.textContent = c.item_count; b.hidden = c.item_count < 1; }
        });
      }).catch(function () {});
    }, 300);
  }
  ['flexi:cushion-added', 'cart:updated', 'cart:refresh', 'cart:update'].forEach(function (n) { document.addEventListener(n, recalerBulle); });
  /* coussins offerts ajoutés par le script du thème après le canapé : le panier latéral se redessine pour les afficher */
  document.addEventListener('flexi:cushion-added', function () {
    evenementsShopify().then(function (m) {
      var Ev = m && m.CartLinesUpdateEvent; if (!Ev) return;
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var cadeau = c.items.filter(function (i) { return i.properties && i.properties._gift; })[0];
        if (!cadeau) return;
        var d = Ev.createPromise();
        document.dispatchEvent(new Ev({ action: 'update', context: 'cart', lines: [{ id: cadeau.key, quantity: cadeau.quantity }], promise: d.promise }));
        /* sans « sections » : le panier latéral recharge lui-même son contenu à jour */
        d.resolve({ cart: Ev.createCartFromAjaxResponse(c), detail: { items: c.items, source: 'fp-cadeau', itemCount: c.item_count, didError: false } });
      });
    }).catch(function () {});
  });
  document.addEventListener('shopify:section:unload', function (e) {
    chaque(qa(e.target, '[data-fp="produit"]'), function (r) { (r.fpSatellites || []).forEach(function (el) { if (el) el.remove(); }); });
  });
})();
